<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2 p-mt-5">
            <Button icon="pi pi-search" @click.prevent="searchSupplierTransaction"
            class="p-button p-component addNewBtn btn-btm-0" label="Search"/>
          </div>

          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="this.supplierTransactionReportList.length > 0" @click.prevent="reset"
                    class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
          </div>

        </div>
      </form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <!-- DataTable for PartyStatement -->
          <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()"
             v-if="this.supplierTransactionReportList.length > 0">
            <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a>
          <DataTable :value="supplierTransactionReportList"
                     :paginator="true" ref="po"
                     :rows="10" :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
                     data-key="id">
            <template #empty>No record found</template>
            <Column header="S.N">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true" header="party Name" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>

            <Column :sortable="true" bodyStyle="text-align: right"
                    header="Opening" field="openingBalance" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Purchase" bodyStyle="text-align: right"
                    field="purchaseAmount" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['purchaseAmount']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Non-taxable" bodyStyle="text-align: right"
                    field="nonTaxableAmount" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['nonTaxableAmount']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Taxable" bodyStyle="text-align: right"
                    field="taxableAmount" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['taxableAmount']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Vat" bodyStyle="text-align: right"
                    field="taxAmount" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter"
                           v-model="filters['taxAmount']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Closing" bodyStyle="text-align: right"
                    field="closingBalance" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['taxAmount']"/>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null,
      supplierTransactionReportList: [],
      account: null,
      columnList: '',
      filters: {},
      englishDateEnabled: true
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async searchSupplierTransaction() {
      let summary = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        type: 'supplier'
      }
      this.loading = true
      let response = await this.$store.dispatch('loadCustomerSupplierTransactionSummary', summary)
      this.loading = false
      this.supplierTransactionReportList = response.data.data
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/supplier' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + 0 + '/supplierTransaction',
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'supplierTransactionSummary.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    reset() {
      this.supplierTransactionReportList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// supplierTransactionSummary.vue?2042e6b6